import { App } from 'vue'
import 'element-plus/dist/index.css'
import {
  ElButton,
  ElForm,
  ElFormItem,
  ElInput,
  ElRadio,
  ElTabs,
  ElTabPane,
  ElCheckbox,
  ElLink,
  ElIcon,
  ElContainer,
  ElAside,
  ElHeader,
  ElMain,
  ElMenu,
  ElMenuItem,
  ElMenuItemGroup,
  ElSubMenu,
  ElDropdown,
  ElDropdownMenu,
  ElDropdownItem,
  ElRow,
  ElCol,
  ElSelect,
  ElOption,
  ElBreadcrumb,
  ElBreadcrumbItem,
  ElDatePicker,
  ElTable,
  ElTableColumn,
  ElPagination,
  ElImage,
  ElDialog,
  ElTree,
  ElCard,
  ElTag,
  ElDescriptionsItem,
  ElDescriptions,
  ElTooltip,
  ElAvatar,
  ElSteps,
  ElStep,
  ElResult,
  ElEmpty,
  ElPopover,
  ElUpload,
  ElAutocomplete,
  ElCascader,
  ElProgress,
  ElInputNumber,
  ElCheckboxGroup,
  ElRadioGroup,
  ElCollapse,
  ElCollapseItem,
  ElTimePicker,
  ElDrawer,
  ElRate,
  ElSelectV2,
  ElSwitch,
  ElText,
  ElRadioButton
} from 'element-plus'

const components = [
  ElButton,
  ElForm,
  ElFormItem,
  ElInput,
  ElRadio,
  ElTabs,
  ElTabPane,
  ElCheckbox,
  ElLink,
  ElIcon,
  ElContainer,
  ElAside,
  ElHeader,
  ElMain,
  ElMenu,
  ElMenuItem,
  ElMenuItemGroup,
  ElSubMenu,
  ElDropdown,
  ElDropdownMenu,
  ElDropdownItem,
  ElRow,
  ElCol,
  ElSelect,
  ElOption,
  ElBreadcrumb,
  ElBreadcrumbItem,
  ElDatePicker,
  ElTable,
  ElTableColumn,
  ElPagination,
  ElImage,
  ElDialog,
  ElTree,
  ElCard,
  ElTag,
  ElDescriptionsItem,
  ElDescriptions,
  ElTooltip,
  ElAvatar,
  ElSteps,
  ElStep,
  ElResult,
  ElEmpty,
  ElPopover,
  ElUpload,
  ElAutocomplete,
  ElCascader,
  ElProgress,
  ElInputNumber,
  ElCheckboxGroup,
  ElRadioGroup,
  ElCollapse,
  ElCollapseItem,
  ElTimePicker,
  ElDrawer,
  ElRate,
  ElSelectV2,
  ElSwitch,
  ElText,
  ElRadioButton
]

export default function (app: App): void {
  for (const component of components) {
    component.name && app.component(component.name, component)
  }
}
